import FetchData from '@shared/utils/fetchData/fetchData';

import { PersonalAccountInfoType } from '../../';

export const getProfileInfoClient = async () => {
  return await FetchData.get<PersonalAccountInfoType>('v2/user/profile', {});
};
